"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectedBoldTypography = exports.SelectNewCustomerLabel = exports.SelectNewCustomer = exports.OtherSelectedBoldTypography = exports.OtherCustomersSectionLoader = exports.NewCustomer = void 0;
var _mui = require("@ori-ui/mui");
const SelectedBoldTypography = exports.SelectedBoldTypography = (0, _mui.styled)(_mui.Typography)(({
  ownerState
}) => ({
  fontWeight: ownerState.selected ? 'bold' : undefined
}));
const OtherSelectedBoldTypography = exports.OtherSelectedBoldTypography = (0, _mui.styled)(SelectedBoldTypography)(({
  theme,
  ownerState
}) => ({
  marginBottom: ownerState.selected ? theme.spacing(2) : undefined
}));
const NewCustomer = exports.NewCustomer = (0, _mui.styled)('div')(({
  theme
}) => ({
  paddingTop: theme.spacing(2),
  marginTop: theme.spacing(2),
  display: 'grid',
  rowGap: theme.spacing(3)
}));
const SelectNewCustomer = exports.SelectNewCustomer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  gridTemplateColumns: `${theme.spacing(7)} auto`,
  gridTemplateAreas: `"new-customer-icon new-customer-label"`,
  paddingTop: theme.spacing(4),
  // fixing the weird gap in the green corner
  marginTop: -1
}));
const SelectNewCustomerLabel = exports.SelectNewCustomerLabel = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  gridArea: 'new-customer-label',
  display: 'flex',
  alignItems: 'center',
  paddingLeft: theme.spacing(1),
  cursor: 'pointer',
  marginRight: 'auto'
}));
const OtherCustomersSectionLoader = exports.OtherCustomersSectionLoader = (0, _mui.styled)(_mui.Skeleton)({
  height: 53
});
